import { Box, styled } from '@mui/material';

export const DialogBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  padding: theme.spacing(4),
}));

export const Title = styled(Box)(({ theme }) => ({
  fontSize: 32,
  fontWeight: 700,
  marginBottom: theme.spacing(2),
}));

export const Message = styled(Box)(({ theme }) => ({
  fontSize: 18,
  marginBottom: theme.spacing(2),
  textAlign: 'center',
  maxWidth: 400,
}));
